import React from "react";
import "./researchheader.css";
// import covid from "../images/covid.jpg";

function ResearchHeader() {
  return (
    <div className="covidImage">
      <div className="covidDiv">
        <p>Current Research</p>
      </div>
    </div>
  );
}

export default ResearchHeader;
